import { render, staticRenderFns } from "./StyleApp.vue?vue&type=template&id=5214b533&"
import script from "./StyleApp.vue?vue&type=script&lang=ts&"
export * from "./StyleApp.vue?vue&type=script&lang=ts&"
import style0 from "./StyleApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports